// ApplicationForm now accepts an optional enableConsentCheck prop (defaults to true)
export { ApplicationForm } from './ApplicationForm';
export { Plaid } from './components/Plaid';
export { Accounting } from './components/Accounting';
export { PreviewTermsCalculator } from './pages/PreviewTermsCalculator';
export { LeadCapturePageA } from './pages/LeadCapturePageA';
export { LeadCapturePageB } from './pages/LeadCapturePageB';
export {
    splitConfig,
    FEATURE_FLAGS,
    getUserKey,
    getUserAttributes,
    env,
} from './config/splitConfig';
export { LeadDataProvider, useLeadData } from './providers/LeadDataProvider';
export { LEAD_FORM_TREATMENTS, getLeadFormComponent } from './config/leadFormTreatments';
export {
    ALLOWED_QUERY_PARAMS,
    extractAllowedParams,
    sanitizeParams,
} from './config/allowedQueryParams';
export type {
    LeadFormData,
    LeadFormWizardOnComplete,
    LeadFormWizardCompletionContext,
} from './forms/LeadFormWizard';
